import { api } from "@/lib/api";
import { markStarted } from "@/lib/progress";

const FLAG = "sap:ws";
const RESERVED = new Set(["sap:started", FLAG]);
const timers = {};

const toolKeys = () => Object.keys(localStorage).filter((k) => k.startsWith("sap:") && !RESERVED.has(k));

const emit = (status) => window.dispatchEvent(new CustomEvent("sap:cloud", { detail: status }));

export const cloudInfo = () => {
  try {
    return JSON.parse(localStorage.getItem(FLAG));
  } catch {
    return null;
  }
};

export const canCloudSave = () => {
  const info = cloudInfo();
  return Boolean(info && info.role !== "governor");
};

export const queueSave = (key, value) => {
  if (!canCloudSave()) return;
  clearTimeout(timers[key]);
  emit("saving");
  timers[key] = setTimeout(async () => {
    try {
      await api.put(`/rc/saves/${key}`, { data: value });
      emit("saved");
    } catch {
      emit("error");
    }
  }, 900);
};

/** After sign-in: the workspace copy wins; anything only in this browser is uploaded. */
export const startCloud = async ({ org, user }) => {
  localStorage.setItem(FLAG, JSON.stringify({ school: org.name, role: user.role }));
  const { data } = await api.get("/rc/saves");
  const saves = data && typeof data === "object" ? data : {};
  Object.entries(saves).forEach(([key, v]) => {
    localStorage.setItem(`sap:${key}`, JSON.stringify(v?.data ?? null));
    markStarted(key);
  });
  if (user.role !== "governor") {
    const uploads = toolKeys().map((k) => k.slice(4)).filter((k) => !(k in saves));
    await Promise.allSettled(uploads.map((k) => api.put(`/rc/saves/${k}`, { data: JSON.parse(localStorage.getItem(`sap:${k}`)) })));
  }
  emit("saved");
  return saves;
};

/** On sign-out the school's answers are removed from this browser. */
export const stopCloud = () => {
  [...toolKeys(), "sap:started", FLAG].forEach((k) => localStorage.removeItem(k));
  window.dispatchEvent(new Event("sap:progress"));
  emit("off");
};
